import React, { FC } from 'react';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import DoneIcon from '@mui/icons-material/Done';
import { DocumentData, Timestamp } from 'firebase/firestore';
import { UserAvatar } from '../../../../shared/components';
import { useSelector } from 'react-redux';
import { Store } from '@/redux';
import '../../components/social.css';

export interface BhabiFirestoreModel extends DocumentData {
  message: string;
  groupID: string;
  name: string;
  avatar: string;
  createdAt: Timestamp;
  senderID: string;
  receiverID: string;
  isRead: string;
  threadID: string[];
}

const formatMessageTime = (ts?: Timestamp): string => {
  if (!ts?.seconds) return '';
  const date = new Date(ts.seconds * 1000);
  return date.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const Message: FC<{
  message: BhabiFirestoreModel;
}> = ({ message }) => {
  const { firebaseUID } = useSelector((state: Store) => state.userReducer);
  const isOwn = firebaseUID === message.senderID;
  const time = formatMessageTime(message.createdAt);
  const read = message.isRead === 'true';

  return (
    <div className="bh-msg" data-own={isOwn}>
      {!isOwn && (
        <UserAvatar
          hideState
          photoURL={message.avatar}
          name={message.name}
          avatarProps={{
            sx: { width: 28, height: 28, flexShrink: 0 },
          }}
        />
      )}
      <div className="bh-msg__bubble">
        {!isOwn && (
          <p className="bh-msg__name" title={message.name}>
            {message.name}
          </p>
        )}
        <p className="bh-msg__text">{message.message}</p>
        <p className="bh-msg__meta">
          {isOwn && <span className="bh-sr-only">You, </span>}
          {time && <time>{time}</time>}
          {isOwn &&
            (read ? (
              <DoneAllIcon
                className="bh-msg__receipt"
                data-read="true"
                titleAccess="Read"
              />
            ) : (
              <DoneIcon className="bh-msg__receipt" titleAccess="Sent" />
            ))}
        </p>
      </div>
    </div>
  );
};
